import { render, staticRenderFns } from "./ChatDateDivider.vue?vue&type=template&id=93b1633c&scoped=true&"
import script from "./ChatDateDivider.vue?vue&type=script&lang=ts&"
export * from "./ChatDateDivider.vue?vue&type=script&lang=ts&"
import style0 from "./ChatDateDivider.vue?vue&type=style&index=0&id=93b1633c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b1633c",
  null
  
)

export default component.exports